import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Box, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      toast.error("Bitte alle Felder ausfüllen");
      return;
    }
    
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Erfolgreich angemeldet");
    } catch (error) {
      const message = error.response?.data?.detail || "Anmeldung fehlgeschlagen";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4" data-testid="login-page">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto p-3 bg-slate-900 rounded-lg w-fit mb-4">
            <Box className="h-8 w-8 text-white" />
          </div>
          <CardTitle className="font-heading text-2xl">Materialausgabe Management</CardTitle>
          <CardDescription>
            Materialausgabe - Anmeldung
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username">Benutzername</Label>
              <Input
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Benutzername"
                className="h-12"
                autoFocus
                data-testid="login-username-input"
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Passwort"
                className="h-12"
                data-testid="login-password-input"
              />
            </div>
            
            <Button 
              type="submit" 
              className="w-full h-12" 
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              ) : (
                <>
                  <LogIn className="h-5 w-5 mr-2" />
                  Anmelden
                </>
              )}
            </Button>
          </form>
          
          <div className="mt-6 p-4 bg-slate-50 rounded-lg space-y-1">
            <p className="text-xs text-slate-500">
              <strong>Admin:</strong> <span className="font-mono">admin</span> / <span className="font-mono">admin123</span>
            </p>
            <p className="text-xs text-slate-500">
              <strong>Materialausgabe:</strong> <span className="font-mono">ausgabe</span> / <span className="font-mono">ausgabe123</span>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
